import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=4eb4085b&scoped=true&"
import script from "./JobDetails.vue?vue&type=script&lang=js&"
export * from "./JobDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobDetails.vue?vue&type=style&index=0&id=4eb4085b&prod&scoped=true&lang=css&"
import style1 from "./JobDetails.vue?vue&type=style&index=1&id=4eb4085b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb4085b",
  null
  
)

export default component.exports